/**
 * --------------------------------------------------------------------------
 * Module: VGFlipList
 * Автор: Vegas DEV
 * Лицензия: смотри LICENSE.md
 * --------------------------------------------------------------------------
 */

class VGFlipList {
	constructor(container, arg = {}) {
		if (!container) {
			console.error('Comrade! The first parameter should not be empty!');
			return false;
		}

		let params = {
			target: []
		}, dataParams = typeof getDataAttribute === 'function' ? (getDataAttribute(container) || {}) : {};

		this.settings = mergeDeepObject(params, arg, dataParams);
		this.element = container;
		this.classes = {
			container: 'vg-flip-list',
			open: 'open',
			closed: 'closed',
			back: 'vg-flip-list--back',
			toggle: 'vg-flip-list--toggle',
			parent: 'vg-flip-list--parent',
			dropdown: 'vg-flip-list--dropdown'
		};

		this.isInit = false;
		this.isEventsBound = false;
		this.onClick = this.onClick.bind(this);

		if (!this.isInit) {
			this.init();
		}
	}

	init() {
		this.element.classList.add(this.classes.container);

		const targets = this.getTargets();
		if (!targets.length) {
			return false;
		}

		targets.forEach((el) => {
			el.classList.add(this.classes.toggle);
			const panel = el.nextElementSibling;

			this.insertBackButton(panel);
			this.preparePanel(panel);
		});

		this.isInit = true;
		this.toggle();

		return true;
	}

	getTargets() {
		if (this.settings.target.length) {
			return this.settings.target;
		}

		return Array.from(this.element.querySelectorAll('[data-vg-toggle="flip-list"]'));
	}

	insertBackButton(container) {
		if (!container) {
			return;
		}

		const tagName = container.tagName;
		const isList = tagName === 'UL';
		const isMegaDropdown = container.classList.contains('dropdown-mega-container');

		if (!isList && !isMegaDropdown) {
			return;
		}

		const firstChild = container.firstElementChild;
		if (
			firstChild &&
			(
				firstChild.classList.contains(this.classes.back) ||
				firstChild.querySelector('.' + this.classes.back)
			)
		) {
			return;
		}

		const wrapper = document.createElement(isList ? 'li' : 'div');
		const link = document.createElement('a');

		link.setAttribute('href', '#');
		link.classList.add(this.classes.back);
		link.innerHTML = this.element.dataset.textBack || '<i class="fal fa-long-arrow-left"></i> Назад';

		wrapper.prepend(link);
		container.prepend(wrapper);
	}

	preparePanel(container) {
		if (!container || !container.children.length) {
			return;
		}

		Array.from(container.children).forEach((child, index) => {
			child.style.setProperty('--vg-flip-index', index);
		});
	}

	onClick(event) {
		const toggle = event.target.closest('.' + this.classes.toggle);
		if (toggle && this.element.contains(toggle)) {
			this.handleToggle(toggle, event);
			return false;
		}

		const back = event.target.closest('.' + this.classes.back);
		if (back && this.element.contains(back)) {
			this.handleBack(back, event);
			return false;
		}

		return true;
	}

	toggle() {
		if (!this.isInit || this.isEventsBound) {
			return false;
		}

		this.element.addEventListener('click', this.onClick);
		this.isEventsBound = true;

		return true;
	}

	handleToggle(toggle, event) {
		event.preventDefault();
		event.stopPropagation();

		const parent = toggle.parentElement;
		const parentList = parent ? parent.parentElement : null;
		if (!parent || !parentList) {
			return false;
		}

		parentList.classList.add(this.classes.closed);
		this.closeOpened();
		parent.classList.add(this.classes.open);

		return false;
	}

	handleBack(back, event) {
		event.preventDefault();
		event.stopPropagation();

		const elOpen = back.closest('.' + this.classes.open);
		const elClosed = back.closest('.' + this.classes.closed);

		if (!elOpen || !elClosed) {
			return false;
		}

		elOpen.classList.remove(this.classes.open);
		elClosed.classList.remove(this.classes.closed);

		const dropdown = elClosed.closest('.dropdown');
		if (dropdown && this.element.contains(dropdown)) {
			dropdown.classList.add(this.classes.open);
		}

		return false;
	}

	closeOpened() {
		this.element.querySelectorAll('.' + this.classes.open).forEach((el) => {
			el.classList.remove(this.classes.open);
		});
	}
}

export default VGFlipList;
